import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "main-view" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = { key: 6 }
const _hoisted_10 = { key: 7 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 8 }
const _hoisted_13 = { key: 9 }
const _hoisted_14 = { key: 10 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, {
      title: _ctx.$route.name,
      iconType: "menu",
      onOnClickLeftIcon: _ctx.onClickLeftIcon
    }, null, 8, ["title", "onOnClickLeftIcon"]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_2, [
          (_ctx.isHouseOwner && !_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createVNode(_component_router_link, {
                  to: "/role-list",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuExpaned=false))
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("角色列表")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isHouseOwner && !_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: "/user-list",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMenuExpaned=false))
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("人員列表")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createVNode(_component_router_link, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/door-status-list"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("門鎖控制狀態")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/access-control-list"
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("門禁系統管理")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/role-list"
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("角色列表")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/user-list"
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("人員列表")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/mail-system"
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("信箱管理系統")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createElementVNode("a", {
                  target: "_blank",
                  rel: "noopener noreferrer",
                  href: _ctx.lockerSystemUrl,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isMenuExpaned = false))
                }, "智能櫃系統", 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/public-facility-booking"
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("公設預約查詢")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/intercom-engineering"
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("工程門口機撥號")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _createVNode(_component_router_link, {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/intercom-devices"
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("對講裝置管理")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _ctx.logout,
              to: "/login"
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createTextVNode("登出")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 512), [
          [_vShow, _ctx.isMenuExpaned]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ]))
}